import { useState } from 'react';

function useSessionStorage(key, initialValue, ignoredFields = []) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setValue = value => {
    let valueToStore = value instanceof Function ? value(storedValue) : value;
    // Ignored fields which should not be be kept in session storage will be mark as undefined
    const ignoredValues = ignoredFields.reduce(
      (accumulate, field) => ({
        ...accumulate,
        [field]: undefined,
      }),
      {}
    );
    valueToStore = { ...valueToStore, ...ignoredValues };
    setStoredValue(valueToStore);
    window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
  };

  return [storedValue, setValue];
}

export default useSessionStorage;
